import { useEffect } from 'react';

import type { VhAdminAccessStatus } from '@/admin/vh-admin-access.store';
import { useVhAdminAccessStore } from '@/admin/vh-admin-access.store';
import { useAuth } from '@/store/auth/auth.store';

/** Shared, cached check for the system admin/super-admin role — the single
 *  place every admin-gated surface (route guard, header link, ...) reads from. */
export const useVhAdminAccess = (): VhAdminAccessStatus => {
  const { isLoggedIn, isInitializing } = useAuth();
  const status = useVhAdminAccessStore((s) => s.status);
  const check = useVhAdminAccessStore((s) => s.check);

  useEffect(() => {
    if (!isInitializing && isLoggedIn) {
      check();
    }
  }, [isInitializing, isLoggedIn, check]);

  if (isInitializing || !isLoggedIn) return 'checking';

  return status;
};
